export default "__VITE_ASSET__DEIsTiAV__"